import { css } from 'styled-components';

const FormInput = css`

width: 100%;
border: 1px solid #ACC2D3;
border-radius: 4px;
height: 40px;
padding: 0 10px;
color: #4A4A4A;

::placeholder {
    color: #8295A3;
    opacity: 1; /* Firefox */
}

`;

export default FormInput;
